import { Result } from "antd";
import Avatar from "boring-avatars";
import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import { useFriends } from "../../data/hooks";
import { fetchProfile } from "../../data/firestore/profile";
import { Id, Wishlist } from "../../data/types";
import { fetchWishlists } from "../../data/firestore/wishlist";
import MobileHeader from "../Components/MobileHeader";
import { generatePath, Link } from "react-router";
import { RoutePaths } from "../routes";
import Button from "../Components/Button";
import WishImage from "./Wishlist/WishImage";
import { analyticsReportError } from "../../data/firebase/analytics";
import Spin from "../Components/Spin";

export default function Friends() {
  const friends = useFriends();
  const title = "My friends";

  const [names, setNames] = useState<Record<Id, string>>({});
  useEffect(() => {
    for (const fid of friends || []) {
      if (!(fid in names)) {
        fetchProfile(fid)
          .then((friendProfile) =>
            setNames((curNames) => ({
              ...curNames,
              [fid]: friendProfile.displayName,
            })),
          )
          .catch(analyticsReportError);
      }
    }
  }, [friends, names]);

  const [wishlists, setWishlists] = useState<Record<Id, Wishlist>>({});
  useEffect(() => {
    for (const fid of friends || []) {
      if (!(fid in wishlists)) {
        fetchWishlists(fid)
          .then((wishlists) =>
            setWishlists((curWishlists) => ({
              ...curWishlists,
              [fid]: wishlists[0],
            })),
          )
          .catch(analyticsReportError);
      }
    }
  }, [friends, wishlists]);

  if (typeof friends === "undefined") {
    return (
      <div className="m-20">
        <Spin />
      </div>
    );
  }

  if (friends.length === 0) {
    return (
      <DocumentTitle title={title}>
        <>
          <MobileHeader title={title}>
            <></>
          </MobileHeader>

          <Result
            icon={<div className="text-5xl">🫥</div>}
            title="No friends yet!"
            subTitle="Ask your friends to send you links to their wishlists!"
            extra={
              <Link to={RoutePaths.myDefaultWishlist} viewTransition>
                <Button>Back to my wishlist</Button>
              </Link>
            }
          />
        </>
      </DocumentTitle>
    );
  }

  return (
    <DocumentTitle title={title}>
      <>
        <MobileHeader title={title}>
          <></>
        </MobileHeader>
        <div className="flex flex-wrap justify-center gap-8 p-8">
          {friends?.map((fid) => {
            const wishlistLink = wishlists[fid]
              ? generatePath(RoutePaths.specificWishlist, {
                  wishlistId: wishlists[fid]?.id,
                })
              : "";
            return (
              <Link to={wishlistLink} key={fid}>
                <div className="wish-border flex min-w-[384px] flex-col gap-4 rounded-2xl border p-4">
                  <div className="flex w-full flex-row items-center gap-4">
                    <Avatar
                      name={fid}
                      size={40}
                      variant={"beam"}
                      viewTransition
                    />
                    <div className="H6 wish-light-primary grow">
                      {names[fid] || <i>Anonymous</i>}
                    </div>
                  </div>
                  <div className="flex h-24 w-full flex-row items-center justify-center gap-4">
                    {(!wishlists[fid]?.items ||
                      wishlists[fid]?.items.length == 0) && (
                      <div>
                        <div className="text-center text-3xl">😇</div>
                        <div className="wish-text-primary">No wishes!</div>
                      </div>
                    )}
                    {wishlists[fid]?.items
                      .filter((it) => it.imageLink)
                      .slice(0, 3)
                      .map((it) => (
                        <WishImage
                          imageLink={it.imageLink || ""}
                          small
                          key={it.id}
                        />
                      ))}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </>
    </DocumentTitle>
  );
}
